export const LIB_VERSION = "1.0.0-beta.90";
